<template>
  <div class="home">
    <div class="banner">
      <a-carousel v-if="bannerList && bannerList.length" :autoplay="true">
        <img v-for="item in bannerList" :key="item.adNo" :src="item.adPicUrl" class="banner-img">
      </a-carousel>
    </div>
    <div class="block-01">
      <div class="sk-block-title">
        <div class="title">数字化赋能传统零售转型升级</div>
        <div class="sub-title">为零售行业用户提供全场景、全方位的数字化综合服务解决方案</div>
      </div>
      <div class="block-01-content">
        <div class="groupItem">
          <div class="title">
            电商解决方案</div>
          <div class="content">
            <div class="item" @click="linkTo('micromall')">
              <img src="@/assets/images/home/home_solution01.png" alt="">
              <span>微商城</span>
            </div>
            <div class="item" @click="linkTo('retail')">
              <img src="@/assets/images/home/home_solution02.png" alt="">
              <span>零售电商</span>
            </div>
            <div class="item" @click="linkTo('chainE')">
              <img src="@/assets/images/home/home_solution03.png" alt="">
              <span>连锁电商</span>
            </div>
            <div class="item item-four" @click="linkTo('community')">
              <img src="@/assets/images/home/home_solution04.png" alt="">
              <span>社群分销</span>
            </div>
            <div class="item" @click="linkTo('live-broadcast')">
              <img src="@/assets/images/home/home_solution05.png" alt="">
              <span>直播电商</span>
            </div>
            <div class="item" @click="linkTo('cloud-purchase')">
              <img src="@/assets/images/home/home_solution06.png" alt="">
              <span>云采购</span>
            </div>
            <div class="item" @click="linkTo('B2B2C')">
              <img src="@/assets/images/home/home_solution07.png" alt="">
              <span>B2B2C</span>
            </div>
          </div>
        </div>
        <div class="groupItem">
          <div class="title">
            智慧收银解决方案</div>
          <div class="content-column">
            <div class="item" @click="linkTo('cashier')">
              <img src="@/assets/images/home/home_solution08.png" alt="">
              <span>智能收银</span>
            </div>
            <div class="item" @click="linkTo('payment')">
              <img src="@/assets/images/home/home_solution09.png" alt="">
              <span>智能支付</span>
            </div>
          </div>
        </div>
        <div class="groupItem">
          <div class="title">
            会员营销解决方案</div>
          <div class="content-column">
            <div class="item" @click="linkTo('member')">
              <img src="@/assets/images/home/home_solution10.png" alt="">
              <span>会员CRM</span>
            </div>
            <div class="item" @click="linkTo('popularize')">
              <img src="@/assets/images/home/home_solution11.png" alt="">
              <span>流量推广</span>
            </div>
          </div>
        </div>
        <div class="groupItem">
          <div class="title">
            企业定制解决方案</div>
          <div class="content-column">
            <div class="item" @click="linkTo('brandCustom')">
              <img src="@/assets/images/home/home_solution12.png" alt="">
              <span>品牌商城</span>
            </div>
            <div class="item" @click="linkTo('shopCustom')">
              <img src="@/assets/images/home/home_solution13.png" alt="">
              <span>门店管理</span>
            </div>
            <div class="item" @click="linkTo('distributeCustom')">
              <img src="@/assets/images/home/home_solution14.png" alt="">
              <span>分销商城</span>
            </div>
            <div class="item" @click="linkTo('O2OCustom')">
              <img src="@/assets/images/home/home_solution15.png" alt="">
              <span>O2O定制</span>
            </div>
          </div>
        </div>
        <div class="groupItem">
          <div class="title">
            产业服务</div>
          <div class="content-column">
            <div class="item" @click="linkTo('finance')">
              <img src="@/assets/images/home/home_solution16.png" alt="">
              <span>金融服务</span>
            </div>
            <div class="item" @click="linkTo('supplychain')">
              <img src="@/assets/images/home/home_solution17.png" alt="">
              <span>供应链服务</span>
            </div>
            <div class="item" @click="linkTo('agent-operation')">
              <img src="@/assets/images/home/home_solution18.png" alt="">
              <span>代运营服务</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="block-02">
      <div class="sk-block-title">
        <div class="title">专注六大行业 聚焦八大场景</div>
        <div class="sub-title">为零售门店提供八大赋能</div>
      </div>
      <img src="@/assets/images/home/home-focus.png" class="home-focus">
    </div>
    <div class="block-03">
      <div class="sk-block-title">
        <div class="title">强大的技术研发团队 保障系统安全稳定</div>
        <div class="sub-title">技术创新有保障 120+项软件著作权 20+科研成果 持续升级</div>
      </div>
      <div class="block-03-content">
        <div>
          <div><span class="number">99.99</span><span class="unit">%</span></div>
          <div class="line">&nbsp;</div>
          <div class="text">系统安全稳定</div>
        </div>
        <div>
          <div><span class="number">5000</span><span class="unit">笔</span></div>
          <div class="line">&nbsp;</div>
          <div class="text">每秒处理订单笔数</div>
        </div>
        <div>
          <div><span class="number">300</span><span class="unit">毫秒</span></div>
          <div class="line">&nbsp;</div>
          <div class="text">服务器平均响应速度</div>
        </div>
        <div>
          <div><span class="number">98</span><span class="unit">%</span></div>
          <div class="line">&nbsp;</div>
          <div class="text">客户满意度高达</div>
        </div>
        <div>
          <div><span class="number">300+</span><span class="unit">人</span></div>
          <div class="line">&nbsp;</div>
          <div class="text">技术团队保驾护航</div>
        </div>
      </div>
    </div>
    <div class="block-04">
      <div class="sk-block-title">
        <div class="title">汇通数科SaaS全国服务网络系统</div>
      </div>
      <div class="block-04-content">
        <div class="map">
          <div class="left">
            <div class="cell">
              <div><span class="number">21</span><span class="unit">个</span></div>
              <div class="text">省及直辖市</div>
            </div>
            <div class="cell">
              <div><span class="number">1.9</span><span class="unit">w+</span></div>
              <div class="text">乡镇</div>
            </div>
            <div class="cell">
              <div><span class="number">14</span><span class="unit">w+</span></div>
              <div class="text">会员零售门店</div>
            </div>
            <div class="cell">
              <div><span class="number">1</span><span class="unit">w+</span></div>
              <div class="text">供应商</div>
            </div>
          </div>
          <div class="right">
            <img src="@/assets/images/home/home_map.png">
          </div>
        </div>
        <div class="coo">
          <div>合作品牌商</div>
          <img src="@/assets/images/home/coopration.png">
        </div>
      </div>
    </div>
    <div class="block-05">
      <div class="sk-block-title">
        <div class="title">权威认证 实力认可</div>
      </div>
      <div class="block-05-content">
        <div class="item"><img src="@/assets/images/home/home-certification-01.png"><div class="name">双软认证</div></div>
        <div class="item"><img src="@/assets/images/home/home-certification-02.png"><div class="name">高新技术企业</div></div>
        <div class="item"><img src="@/assets/images/home/home-certification-03.png"><div class="name">企业信用等级证书（aaa）</div></div>
        <div class="item"><img src="@/assets/images/home/home-certification-04.png"><div class="name">网络安全等级 保护2.0（三级）</div></div>
        <div class="item"><img src="@/assets/images/home/home-certification-05.png"><div class="name">质量管理体系认证</div></div>
      </div>
    </div>
    <div class="block-06">
      <div class="title">请留下您的联系方式，我们将第一时间与您沟通</div>
      <div class="content">
        <a-form :form="form" @submit="handleSubmit">
          <a-form-item>
            <a-input
              v-decorator="['name', { rules: [{ required: true, message: '请输入姓名!' }] }]"
              placeholder="请输入您的姓名"
            />
          </a-form-item>
          <a-form-item>
            <a-input
              v-decorator="['phone', { rules: [{
                required: true,
                message: '请输入手机号!'
              }, {
                validator: checktelphone,
              }] }]"
              placeholder="请输入您的手机号"
            />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" html-type="submit" block>
              信息提交
            </a-button>
          </a-form-item>
        </a-form>
      </div>
      <div id="captcha" />
    </div>
  </div>
</template>
<script>
import metaInfo from '@/common/util/metaInfo'
import { getAdvertiseList, simpleInformationCollection, browseCount } from '@/apis/index'
export default {
  name: 'Index',
  metaInfo: metaInfo.Index,
  components: {
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'connact' }),
      bannerList: [],
      captchaIns: null,
      params: null
    }
  },
  mounted() {
    this.getBannerList()
    this.getCode()
  },
  methods: {
    linkTo(path) {
      if (!path.startsWith('/')) {
        path = '/' + path
      }
      this.$router.push({ path })
      browseCount()
    },
    checktelphone(rule, value, callback) {
      const reg = /^1[3456789]\d{9}$/
      if (value && !(reg.test(value))) {
        callback('请输入正确的手机号码！')
      } else {
        callback()
      }
    },
    getBannerList() {
      // 1：订阅，2：工作台，3:首页，4:PC官网首页，5:h5官网首页
      var params = { releaseSystemLocation: 4 }
      getAdvertiseList(params).then(res => {
        this.bannerList = res
      }).catch(err => {
        this.$message.error(err)
      })
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.captchaIns.popUp()
          this.params = {
            infoSources: '首页',
            officialWebsiteEntrance: 'PC',
            name: values.name,
            phone: values.phone
          }
        }
      })
    },
    getCode() {
      const that = this
      // eslint-disable-next-line no-undef
      initNECaptcha && initNECaptcha({
        element: '#captcha',
        captchaId: '6c0483e901164a789d9d13f0291ba257',
        mode: 'popup',
        width: '320px',
        // enableClose: true,
        onClose: function() {
          // 弹出关闭结束后将会触发该函数
        },
        onVerify: function(err, data) {
          if (err) return
          // that.captchaIns.close()
          that.params.pictureCode = data.validate
          simpleInformationCollection(that.params).then(res => {
            that.$message.success({
              content: '感谢您的信息提交，我们将会有专员与您联系~',
              duration: 1
            })
            that.captchaIns.refresh()
            that.form.resetFields()
          }).catch(err => {
            that.$message.error(err)
            that.captchaIns.refresh()
          })
        }
      }, function(instance) {
        // 初始化成功后得到验证实例instance，可以调用实例的方法
        that.captchaIns = instance
      }, function(err) {
        console.log(err)
        // 初始化失败后触发该函数，err对象描述当前错误信息
      })
    }
  }
}
</script>
<style lang="less" scoped>
.banner-img {
  width: 100%;
  min-width: 1200px;
  height: 420px;
  object-fit: cover;
}
.block-01 {
  background: #FAFAFA;
  overflow: hidden;
  .block-01-content {
    padding: 56px 0 58px 0;
    width: 1200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    .groupItem {
      width: 224px;
      height: 410px;
      .title {
        font-size: 18px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 68px;
      }
      .item {
        min-width: 56px;
        display: flex;
        flex-direction: column;
        margin-bottom: 15px;
        img {
          display: block;
          width: 40px;
          height: 40px;
          margin: 0 auto;
        }
        span {
          font-size: 14px;
          font-weight: 500;
          color: #595961;
          padding-top: 5px;
        }
      }
      .content {
        height: 342px;
        padding: 18px 42px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        background: #fff;
        .item-four {
          img {
            width: 38px;
            height: 30px;
          }
          span {
            padding-top: 15px;
          }
        }
        .item {
          cursor: pointer;
        }
      }
      .content-column {
        height: 342px;
        flex-direction: column;
        align-items: center;
        background: #fff;
        padding-top: 18px;
        .item {
          margin: 0 auto 15px;
          cursor: pointer;
        }
      }
    }
    .groupItem:nth-child(1) {
      background: url("~@/assets/images/home/home-pic-01.png") no-repeat;
    }
    .groupItem:nth-child(2) {
      background: url("~@/assets/images/home/home-pic-02.png") no-repeat;
    }
    .groupItem:nth-child(3) {
      background: url("~@/assets/images/home/home-pic-03.png") no-repeat;
    }
    .groupItem:nth-child(4) {
      background: url("~@/assets/images/home/home-pic-04.png") no-repeat;
    }
    .groupItem:nth-child(5) {
      background: url("~@/assets/images/home/home-pic-05.png") no-repeat;
    }
  }
}
.block-02 {
  background: #FFFFFF;
  overflow: hidden;
  .home-focus {
    width: 1124px;
  }
}
.block-03 {
  height: 426px;
  background: url('~@/assets/images/home/home-bg-01.png') no-repeat 0 0;
  .sk-block-title {
    .title {
      color: #FFFFFF;
    }
    .sub-title {
      color: #BDBDBD;
    }
  }
  .block-03-content {
    width: 1200px;
    margin: 60px auto 0 auto;
    display: flex;
    justify-content: space-between;
    color: #FFFFFF;
    &>div{
      text-align: left;
    }
    .number {
      font-size: 46px;
      font-weight: 600;
      line-height: 65px;
    }
    .unit {
      margin-left: 7px;
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
    }
    .line {
      margin-top: 11px;
      width: 68px;
      height: 8px;
      background: #3986FF;
    }
    .text {
      margin-top: 20px;
      font-size: 16px;
      font-weight: 400;
      color: #BDBDBD;
      line-height: 22px;
      text-align: left;
    }
  }
}
.block-04 {
  background: #FAFAFA;
  .block-04-content {
    width: 1200px;
    margin: 0 auto;
    text-align: left;
    padding-top: 14px;
    .left {
      display: inline-block;
      vertical-align: top;
    }
    .right {
      margin-left: 189px;
      display: inline-block;
      vertical-align: top;
      img {
        width: 692px;
      }
    }
    .cell {
      width: 163px;
      padding: 17px 0 28px 0;
    }
    .cell:not(:last-child) {
      border-bottom: 1px solid #DFE0E7;
    }
    .number {
      font-size: 48px;
      font-weight: bold;
      color: #3986FF;
      line-height: 56px;
    }
    .unit {
      font-size: 24px;
      font-weight: bold;
      color: #3986FF;
      line-height: 31px;
    }
    .text {
      margin-top: 6px;
      font-size: 16px;
      color: #595961;
      line-height: 21px;
    }
    .coo {
      text-align: center;
      &>div {
        font-size: 36px;
        font-weight: 500;
        color: #595961;
        line-height: 42px;
      }
      img {
        margin: 40px 0 50px 0;
      }
    }
  }
}
.block-05 {
  background-color: #FFFFFF;
  .block-05-content {
    width: 1100px;
    display: flex;
    margin: 0 auto;
    justify-content: space-between;
    text-align: center;
    padding-bottom: 72px;
    .name {
      width: 120px;
      font-size: 16px;
      font-weight: 400;
      color: #595961;
      line-height: 22px;
      margin: 0 auto;
    }
  }
}
.block-06 {
  height: 409px;
  background: url('~@/assets/images/home/home-bg-02.png') no-repeat 0 0;
  padding: 50px 0 55px 0;
  text-align: center;
  .title {
    font-size: 30px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 42px;
  }
  .content {
    width: 500px;
    margin: 40px auto 0 auto;
    /deep/ .ant-btn-primary {
      height: 58px;
      font-size: 23px;
    }
  }
}
</style>
